import React from 'react';
import { useDroppable } from '@dnd-kit/core';
import { SortableContext, rectSortingStrategy } from '@dnd-kit/sortable';
import { cn } from '@/lib/utils';
import { Card } from '@/components/ui/card';
import { SortableTaskItem } from './sortable-task-item';
import { Task } from '@shared/schema';

interface CalendarDayColumnProps {
  id: string;
  isToday: boolean;
  tasks: Task[];
  onTaskClick?: (taskId: number) => void;
}

export function CalendarDayColumn({ id, isToday, tasks, onTaskClick }: CalendarDayColumnProps) {
  const { setNodeRef, isOver } = useDroppable({
    id
  });
  
  return (
    <div
      ref={setNodeRef}
      className={cn(
        "min-h-[12rem] lg:min-h-[15rem] p-2 rounded-md transition-colors bg-background/40 border",
        isToday && "bg-primary/5 border-primary/20",
        isOver && "bg-muted/60 border-dashed"
      )}
    >
      <SortableContext items={tasks.map(task => task.id)} strategy={rectSortingStrategy}>
        <div className="space-y-2">
          {tasks.map(task => (
            <SortableTaskItem 
              key={task.id} 
              task={task} 
              onClick={() => onTaskClick?.(task.id)} 
            />
          ))}
        </div>
      </SortableContext>
    </div>
  );
}